import React from 'react';
import { Field } from 'redux-form';
import messages from './messages';
import {
  renderPhoneField,
  phoneParser,
  phoneFormatter,
} from '../../../../utils/redux-form-helper';

type Props = {
  intl: any,
  fieldName: string,
};

const PhoneNumber = ({ intl, fieldName }: Props) => (
  <section>
    <Field
      className="input-lg"
      name={fieldName}
      component={renderPhoneField}
      placeholder={intl.formatMessage(messages.placeholder)}
      parse={phoneParser}
      format={phoneFormatter}
    />
  </section>
);

export default PhoneNumber;
